/**
 * Single source of truth for supported locales and the locale cookie name.
 * Imported by both i18n/request.ts (server) and the LanguageSwitcher (client)
 * so a change in one place updates both automatically.
 */

export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";

export const SUPPORTED_LOCALES = [
  { code: "en-US", label: "EN" },
  { code: "es-US", label: "ES" },
] as const;

export type LocaleCode = (typeof SUPPORTED_LOCALES)[number]["code"];

/** Type guard — returns true if value is a supported locale code */
export function isSupportedLocale(value: string | undefined): value is LocaleCode {
  return value !== undefined && SUPPORTED_LOCALES.some((l) => l.code === value);
}

export const DEFAULT_LOCALE: LocaleCode = "en-US";
